import { StrukturellesFormat, type ThemaFromThemaRouter } from '../dtos';
import { unique } from './unique';

const formatLabels: Partial<Record<StrukturellesFormat, string>> = {
  PRUEFUNG_PRAESENZ_VA: 'Prüfung Präsenz-VA',
  BLENDED_LEARNING: 'Blended Learning',
  ONLINE_KURS_VC_MIT_MODULEN: 'Online-Kurs (VC mit Modulen)',
  SEMINAR_STANDARD: 'Seminar (Standard)',
  KI_LOOP_PRODUKT: 'KI Loop',
};

export const printCservFormat = ({ produkte }: Pick<ThemaFromThemaRouter, 'produkte'>): string =>
  produkte
    .map(({ strukturellesFormat }) => formatLabels[strukturellesFormat])
    .filter(unique)
    .filter(Boolean)
    .join(', ');
